import { Injectable, signal } from "@angular/core";

/** El menú lateral de formularios: lo dibuja el sidenav y una pantalla lo puede plegar, como en pantalla completa. */
@Injectable({
  providedIn: "root",
})
export class SidenavService {
  /** El sidenav lo vuelve a su estado por defecto en cada navegación: lo que pliega una pantalla no pasa a otra. */
  public readonly abierto = signal<boolean>(false);
}
